import { executeRequest, JFSRequest } from '@jfs/network'
import { jsonToGraphQLQuery } from 'json-to-graphql-query'
import { isSuccessResponse } from '../utils'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'

const getTerminalId = (entity, deviceSerialNo) => {
  return entity?.terminalDetails?.find((item) => item?.device?.deviceSerialNo === deviceSerialNo)?.terminalId ?? 'NA'
}

const responseParser = (response: any, searchByKey, searchString) => {
  const data = isSuccessResponse(response)
  const entity = data?.data?.findEntity?.entitySearchList?.[0]
  if (!entity?.deviceDetails || entity?.deviceDetails.length === 0) {
    throw { code: 'EMS011', message: 'No Records Found' }
  }
  return (
    entity?.deviceDetails
      // ?.filter((device: any) => device.linkingStatus === 'ACTIVE')
      ?.map((item: any) => {
        return {
          sMid: entity?.parent?.identificationNumber ?? 'NA',
          mid: entity?.identificationNumber ?? 'NA',
          tid: item.deviceLinkingStatus === 'ACTIVE' ? getTerminalId(entity, item?.deviceSerialNo) : 'NA',
          dsn: item?.deviceSerialNo ?? 'NA',
          status:
            item.deviceLinkingStatus === 'ACTIVE'
              ? 'ACTIVE'
              : item?.deviceStatus === 'A'
                ? 'Linked with MID'
                : 'INACTIVE',
          link: item.deviceLinkingStatus === 'ACTIVE' || item?.deviceStatus === 'A' ? 'Delink' : '',
          createdDate: item?.entityIdLinkDate ?? 'NA',
          deviceType: 'POS',
        }
      })
      .filter((item) => {
        if (searchByKey === 'tid') {
          return item.tid === searchString
        }
        if (searchByKey === 'deviceSerialNumber') {
          return item.dsn === searchString
        }
        return true
      })
  )
}
const searchEMSDeviceMappings = (req: any, tokens: any) => {
  const { REACT_APP_ENV } = window?._env_
  const { entityId, deviceSerialNumber, tid } = req
  let searchByKey = '',
    searchString = ''
  if (entityId) {
    searchByKey = 'entityId'
    searchString = entityId
  } else if (deviceSerialNumber) {
    searchByKey = 'deviceSerialNumber'
    searchString = deviceSerialNumber
  } else {
    searchByKey = 'tid'
    searchString = tid
  }
  const apiPath =
    REACT_APP_ENV === 'pp' || REACT_APP_ENV === 'prod'
      ? APIEndPoints.searchEntityPPV2
      : getUrl(APIEndPoints.searchEntity)

  const query = {
    findEntity: {
      __args: {
        [searchByKey]: searchString,
        page: 1,
        size: 5,
      },
      entitySearchList: {
        parent: {
          identificationNumber: true,
        },
        identificationNumber: true,
        terminalDetails: {
          terminalId: true,
          device: {
            deviceSerialNo: true,
            deviceStatus: true,
            deviceLinkingStatus: true,
            entityIdLinkDate: true,
          },
        },
        deviceDetails: {
          deviceSerialNo: true,
          deviceStatus: true,
          deviceLinkingStatus: true,
          entityIdLinkDate: true,
        },
      },
      page: {
        size: true,
        totalElements: true,
        totalPages: true,
        number: true,
      },
    },
  }

  const gqlQuery = `{${jsonToGraphQLQuery(query, { pretty: false })}}`
  const request: JFSRequest<{}> = {
    apiPath: apiPath,
    method: 'POST',
    cache: false,
    config: sitConfig(tokens),
    headers: getHeaders(),
    body: gqlQuery,
  }
  return executeRequest(request)
    .then((resp) => responseParser(resp, searchByKey, searchString))
    .catch((error) => {
      throw error
    })
}
export { searchEMSDeviceMappings }
